import {useMemo} from "react";

import {useAccommodationsQuery} from "./query";


const useAccommodations = () => {

    // the query return a list of accommodation with their units
    const accommodationsQuery = useAccommodationsQuery();

    // Array of accommodations with and without the archived ones
    const accommodationsAll = useMemo(
        () => accommodationsQuery.data || [],
        [accommodationsQuery.data]
    )
    const accommodations = useMemo(
        () => (
            accommodationsAll.filter(a => a.archivedAt === null)
                .map(a => ({...a, units: a.accommodationUnits.filter(u => u.archivedAt === null)}))),
        [accommodationsAll]
    )

    // Array of accommodation units with the (parent) accommodation
    // ordered by accommodation name and unit name
    const accommodationUnitsAll = useMemo(
        () => (
            accommodationsQuery.data?.flatMap(a => a.accommodationUnits.map(u => {
                const {accommodationUnits, ...acc} = a;
                return {...u, accommodation: acc}
            }))?.sort((a, b) => a.accommodation.name.localeCompare(b.accommodation.name) || a.name.localeCompare(b.name))
            || []),
        [accommodationsQuery.data]
    )

    const accommodationUnits = useMemo(
        () => accommodationUnitsAll.filter(u => u.archivedAt === null),
        [accommodationUnitsAll]
    )

    // Find an accommodation unit by type and id.
    // Tt returns both archived and unarchived units. This is useful to find a unit
    // and show its data even it is archived as it migth happen in old booking, quote,
    // etc.
    const findAccommodationUnit = (type, id) => {
        return accommodationUnitsAll.find(u => u.type === type && u.id === id);
    }

    const findApartment = (id) => {
        return findAccommodationUnit("Apartment", id);
    }

    return {
        accommodations,
        accommodationUnits,
        findAccommodationUnit,
        findApartment,
        isLoading: accommodationsQuery.isLoading,
    }
}

export default useAccommodations;